import { render, staticRenderFns } from "./AddReservation.vue?vue&type=template&id=87787a9c&scoped=true&"
import script from "./AddReservation.vue?vue&type=script&lang=js&"
export * from "./AddReservation.vue?vue&type=script&lang=js&"
import style0 from "./AddReservation.vue?vue&type=style&index=0&id=87787a9c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87787a9c",
  null
  
)

export default component.exports